export default class ItemSaleDto {
  public r: string; //receiptId
  public d: number; // date
  public t: string; //receiptItemId
  public i: string; //itemId
  public q: number; //quantity
  public a: number; //amount
}
